import { Motion, spring } from 'react-motion';
import { Component, React } from '../../react';
import { Btn } from '../../react-toolbox-redesign/button';
import cx from './style.less';

export default class CollapsablePanel extends Component<{ label: React.ReactChild; border?: boolean; defaultOpened?: boolean; }, any> {
    public state = {
        contentHeight: 0,
        visible: Boolean(this.props.defaultOpened),
    };

    private _contentHeight: number = 0;
    private _initialHeight: number = undefined;
    private _content: HTMLDivElement;
    private _queue: any;
    
    public render() {
        const { label, border, children } = this.props;
        const { contentHeight, visible } = this.state;

        return (
            <Motion defaultStyle={{ maxHeight: 0 }} style={{ maxHeight: this.getInitialHeight(visible, contentHeight) }}>
                {({ maxHeight }: { maxHeight: number }) => (
                    <div className={cx('component', { border }) }>
                        <div className={cx('header', { border })}>
                            <Btn 
                                type="button" 
                                className={cx('btn-type-dropdown')} 
                                aria-haspopup={false}                        
                                tabIndex={0}                                                                                                                        
                                onClick={this.onClick}
                                disabled={false}>
                                    <span className={cx('selected-container')}>
                                        <span className={cx('default-header')}>{label}</span>
                                    </span>
                                    <span className={cx('icon', visible? 'icon_chevron-up': 'icon_chevron-down')}></span>
                            </Btn>  
                            
                        </div>
                        <div 
                            className={cx(!visible? 'wcag-invisible' : '', 'content', { opened: contentHeight > 0 && maxHeight === contentHeight })}
                            style={{ maxHeight: contentHeight > 0 && maxHeight === contentHeight ? 'initial' : maxHeight }}
                            ref={this.onContentMounted}>
                            { children }                      
                        </div>
                    </div>
                )}
            </Motion>
        );
    }

    public componentWillReceiveProps({ children }: any) {
        if (children !== this.props.children) {
            this.beginUpdate();
        }
    }

    public componentDidMount() {
        this._initialHeight = undefined;
        this.beginUpdate();
    }

    public componentDidUpdate() {
        this.beginUpdate();
    }

    private getInitialHeight(visible: boolean, input: number) {
        if (this._initialHeight) {
            const h = this._initialHeight;
            this._initialHeight = 0;
            return visible ? h : 0;
        } else {
            return spring(visible ? input : 0);
        }
    }

    private onContentMounted = (div: HTMLDivElement) => {
        this._content = div;
        this.beginUpdate();
    }
    private beginUpdate = () => {
        if (!this._queue) {
            this._queue = window.requestAnimationFrame(this.update);
        }
    }
    private update = () => {
        this._queue = null;
        if (this._content) {
            const contentHeight = this._content.scrollHeight || 0;
            if (this._initialHeight === undefined) {
                this._initialHeight = contentHeight;
            }
            if (this.state.visible && contentHeight !== this._contentHeight) {
                this._contentHeight = contentHeight;
                this.setState({ contentHeight });
            }
        }
    }

    private onClick = () => {
        this.setState({ visible: !this.state.visible });
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/collapsiblePanel/index.tsx